import { Outlet, Navigate, useLocation } from "react-router-dom";

const ProtectRoutes = () => {
  const location = useLocation();
  const isAuthenticated = !!localStorage.getItem("token"); // or however you manage auth

  if (!isAuthenticated) {
    return <Navigate to="/SignIn" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default ProtectRoutes;